module.exports = __webpack_public_path__ + "img/menubar_pic01.b54ffbfe.jpg";